import { Outlet, createRootRoute, HeadContent } from "@tanstack/react-router";
import { Language } from "@linqx/i18n";
import { SmoothScroll } from "@/components/motion/smooth-scroll";

/**
 * SPA root. The <html>/<head>/<body> shell lives in index.html (with a static
 * SEO baseline for non-JS scrapers); here we manage per-route <head> at runtime
 * via <HeadContent /> for JS-capable crawlers and in-app navigation.
 */
export const Route = createRootRoute({
  head: () => ({
    meta: [
      { title: Language.getKey("landing_meta_home_title") },
      {
        name: "description",
        content: Language.getKey("landing_meta_root_description"),
      },
      { name: "theme-color", content: "#5E3A3A" },
    ],
  }),
  component: RootComponent,
});

function RootComponent() {
  return (
    <>
      <HeadContent />
      <SmoothScroll>
        <Outlet />
      </SmoothScroll>
      <div className="grain-overlay" aria-hidden />
    </>
  );
}
